export const relationships = [
  'Mother',
  'Father',
  'Sibling',
  'Maternal Grandparent',
  'Fraternal Grandparent',
  'Uncle/Aunt',
  'Cousin',
]
